import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Collapse,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
} from '@mui/icons-material';

interface CollapsibleCardProps {
  title: string;
  icon: React.ReactNode;
  expanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const CollapsibleCard: React.FC<CollapsibleCardProps> = ({
  title,
  icon,
  expanded,
  onToggle,
  children,
}) => {
  return (
    <Card
      sx={{
        width: '100%',
        height: expanded ? 'auto' : 'fit-content',
      }}
    >
      <CardHeader
        onClick={onToggle}
        sx={{
          cursor: 'pointer',
          transition: 'background 0.2s',
          padding: '12px 16px',
          '&:hover': {
            backgroundColor: '#fafafa',
          },
          '& .MuiCardHeader-content': {
            overflow: 'hidden',
          },
          '& .MuiCardHeader-action': {
            margin: 0,
            alignSelf: 'center',
          },
        }}
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ color: 'primary.main', display: 'flex', alignItems: 'center' }}>
              {icon}
            </Box>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 600,
                color: '#1a1a2e',
              }}
            >
              {title}
            </Typography>
          </Box>
        }
        action={
          <IconButton
            size="small"
            sx={{
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s',
              color: '#9e9e9e',
            }}
            onClick={(e) => {
              e.stopPropagation();
              onToggle();
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
        }
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent sx={{ paddingTop: 0 }}>{children}</CardContent>
      </Collapse>
    </Card>
  );
};

export default CollapsibleCard;
